import { Button, Grid, Modal, Typography } from 'antd';
import { useEffect, useState } from 'react';

const { useBreakpoint } = Grid;
const { Paragraph } = Typography;

function MobileWarningModal() {
    const screens = useBreakpoint();

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [hasUserContinued, setHasUserContinued] = useState(
        localStorage.getItem('mobile_warning_continued') === 'true'
    );

    const breakpointsReady = Object.values(screens).some(v => v !== undefined);

    useEffect(() => {
        if (!breakpointsReady) return;  // Don't run logic until breakpoints are known

        const isSmallScreen = !screens.md;

        // Show the modal if it's a small screen AND the user hasn't already chosen to continue
        if (isSmallScreen && !hasUserContinued) {
            setIsModalVisible(true);
        } else {
            setIsModalVisible(false);
        }
    }, [screens, hasUserContinued, breakpointsReady]);

    const handleContinue = () => {
        localStorage.setItem('mobile_warning_continued', 'true');
        setHasUserContinued(true);
        setIsModalVisible(false);
    };

    return (
        <Modal
            title="⚠️ Optimised for Desktop"
            open={isModalVisible}
            closable={false}
            maskClosable={false}
            footer={null}
            centered
            width={400}
        >
            <Paragraph>
                WeLearn does not support small screens &mdash; yet. Consider switching for <strong>a desktop or
                    a large tablet</strong> for the best user experience.
            </Paragraph>
            <Paragraph>
                The app may be difficult to use in for such screen resolution.
            </Paragraph>

            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                <Button key="submit" type="primary" onClick={handleContinue}>
                    Continue Anyway
                </Button>
            </div>
        </Modal>
    );
}

export default MobileWarningModal;
